module.exports = __webpack_public_path__ + "static/media/nofiles.f9c84e6f.svg";